/// *** System import ***///
import { Component } from '@angular/core';
import { ViewController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../../app/globals';
import { SessionProvider } from '../../../../../providers/session';
import { Account_TransactionHistoryStore } from '../../transactionHistory.store';

@Component({
  selector: 'page-account-transactionHistory-params',
  templateUrl: 'params.html',
})
export class Account_TransactionHistoryParamsPopover {
  /// *** Data ***///
  private account: any;
  private startDate: Date;
  private endDate: Date;
  constructor(
    // *** System
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    private session: SessionProvider,
    private store: Account_TransactionHistoryStore) {
    this.account = this.session.accounts.find((account) => {
      return account.AccountID == this.store.params.account.AccountID;
    });
    this.startDate = this.store.params.startDate.toISOString();
    this.endDate = this.store.params.endDate.toISOString();
  }

  // *** Fermer la fenêtre et appliquer les paramètres
  private _dismiss() {
    try {
      this.store.params.account = this.account;
      this.store.params.startDate = new Date(this.startDate);
      this.store.params.endDate = new Date(this.endDate);
      this.viewCtrl.dismiss();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/transactionHistory/popovers/params/params.ts